import React, {useEffect, useState} from "react";
import Modal from "react-modal";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {useTrackGoogleAnalyticsEventPages} from "../../common/hooks/useTrackGoogleAnalyticsEvent";
import { signInWithToken } from '../../api/apiAuth';
import { getAuth } from 'firebase/auth';
import { getIsReactNativeWrapper, getIsV2AppVersion, getSessionId, getWrapperPlatform } from "../../App";
interface Props {}

const LoggingIn: React.FC<Props> = () => {
   
   const auth = getAuth();
   const [searchParams] = useSearchParams(); 
   const token = searchParams.get('token');
  const navigate = useNavigate();   
 useEffect(() => {  
    const validateAndLogin = async () => {   
           
      if (token) {       
        try {        
          await signInWithToken(auth, token);
          const v2 = getIsV2AppVersion() ? "&isV2AppVersion=true&isAppV2Version=true" : "";
          const sessionId = getSessionId();
          const session = sessionId ? `&sessionId=${encodeURIComponent(sessionId)}` : "";
          const url = `/game?wrapperPlatform=${getWrapperPlatform()}&isReactNativeWrapper=${getIsReactNativeWrapper()}${v2}${session}`;
          navigate(url, { replace: true });          
          window.location.href = url;            
        } catch (error) {
          console.error('Token validation failedee:', error);
        }
      }
    };

    validateAndLogin();
  }, []);

  // useEffect(() => {
  //   useTrackGoogleAnalyticsEventPages('/forgot-password','forgot password page')
  // }, []);

  return (
    <>
      <div className="container xs-container--sm">
         <div className="flex flex-col w-100 xs-px-6 sm-px-5 text-start ">
          <h2 className="fs-h-3 lh-h-3 sm-fs-h-5 sm-lh-h-5 xs-fs-h-7 xs-lh-h-7 c-text-4 mb-12">
            Logging Inm
          </h2>
         
        </div>
       </div>
    </>
  );
};

export default LoggingIn;
